// extracted by mini-css-extract-plugin
module.exports = {"label":"ChannelLabel_label__3Ofj_","singleRow":"ChannelLabel_singleRow__2fDSn","icon":"ChannelLabel_icon__3pLob","text":"ChannelLabel_text__3TAJH"};